import axios, { AxiosInstance } from 'axios';

import { store } from 'redux/reducers';

import { APP_LANGUAGE, MAIN_BACKEND_URL } from '../config/Config';

const instance: AxiosInstance = axios.create({
  baseURL: MAIN_BACKEND_URL,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    lang: APP_LANGUAGE,
  },
});

// Inyectar headers de impersonación cuando el SUPER_ADMIN opera en otro contexto.
instance.interceptors.request.use((config) => {
  const state = store.getState();
  const companyId: number | null = state?.impersonation?.companyId ?? null;
  const roleIds: number[] = state?.impersonation?.roleIds ?? [];

  if (companyId !== null) {
    config.headers['x-company-id'] = String(companyId);
    if (roleIds.length > 0) {
      config.headers['x-role-ids'] = roleIds.join(',');
    }
  }

  return config;
});

export default instance;
